import React, { useState, useEffect } from 'react';
import { Tag, Plus } from 'lucide-react';
import { tagsAPI } from '../services/api';

const TagSelector = ({ value, onChange, clienteId, darkMode, showLabel = true }) => {
  const [tags, setTags] = useState([]);
  const [showNewTagForm, setShowNewTagForm] = useState(false);
  const [newTag, setNewTag] = useState({ nome: '', cor: '#3B82F6' });

  useEffect(() => {
    if (clienteId) {
      loadTags();
    }
  }, [clienteId]);

  const loadTags = async () => {
    try {
      console.log('Carregando tags para cliente:', clienteId);
      const response = await tagsAPI.list(clienteId);
      console.log('Tags carregadas:', response.data);
      setTags(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar tags:', error);
    }
  };

  const handleCreateTag = async () => {
    if (!newTag.nome.trim()) return;
    try {
      const response = await tagsAPI.create({
        cliente_id: clienteId,
        nome: newTag.nome,
        cor: newTag.cor,
      });
      setTags([...tags, response.data]);
      onChange(response.data.id);
      setNewTag({ nome: '', cor: '#3B82F6' });
      setShowNewTagForm(false);
    } catch (error) {
      console.error('Erro ao criar tag:', error);
    }
  };

  return (
    <div>
      {showLabel && (
        <label className={`block text-xs font-medium mb-1.5 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
          <Tag className="inline h-3 w-3 mr-1" />
          Tag para Atendimento
        </label>
      )}
      {!showNewTagForm ? (
        <div className="flex gap-2">
          <select
            value={value || ''}
            onChange={(e) => onChange(e.target.value || null)}
            className={`flex-1 text-sm border rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              darkMode ? 'bg-zinc-700 border-zinc-600 text-gray-300' : 'bg-white border-gray-300 text-gray-700'
            }`}
          >
            <option value="">Selecione uma tag...</option>
            {tags.map(tag => (
              <option key={tag.id} value={tag.id}>
                {tag.nome}
              </option>
            ))}
          </select>
          <button
            type="button"
            onClick={() => setShowNewTagForm(true)}
            className="px-2 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-xs font-medium flex items-center gap-1"
          >
            <Plus className="h-3 w-3" />
          </button>
        </div>
      ) : (
        <div className={`border rounded-lg p-2 ${darkMode ? 'border-zinc-600 bg-zinc-700' : 'border-gray-300 bg-gray-50'}`}>
          <div className="flex gap-2 mb-2">
            <input
              type="text"
              value={newTag.nome}
              onChange={(e) => setNewTag({ ...newTag, nome: e.target.value })}
              placeholder="Nome da tag"
              className={`flex-1 text-xs border rounded px-2 py-1 ${
                darkMode ? 'bg-zinc-600 border-zinc-500 text-white' : 'bg-white border-gray-300'
              }`}
              onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleCreateTag())}
            />
            <input
              type="color"
              value={newTag.cor}
              onChange={(e) => setNewTag({ ...newTag, cor: e.target.value })}
              className="w-10 h-7 rounded cursor-pointer"
            />
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={handleCreateTag}
              className="flex-1 px-2 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700"
            >
              Criar
            </button>
            <button
              type="button"
              onClick={() => {
                setShowNewTagForm(false);
                setNewTag({ nome: '', cor: '#3B82F6' });
              }}
              className="flex-1 px-2 py-1 bg-gray-600 text-white rounded text-xs hover:bg-gray-700"
            >
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TagSelector;
